import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';

export default function CustomPieChart({ UFOBurned, UFOLiquidity, UFOHold }) {

  const data = [
    { id: 0, value: UFOBurned === 0 ? 1 : UFOBurned, name: "UFO Burned", shortname: "Burned", color: "#e8ffc0" },
    { id: 1, value: UFOLiquidity === 0 ? 1 : UFOLiquidity, name: "UFO Liquidity", shortname: "Liquidity", color: "#d0ff80" },
    { id: 2, value: UFOHold === 0 ? 1 : UFOHold, name: "UFO Hold", shortname: "Hold", color: "#b8ff40" },
  ];

  const totalValue = data.reduce((sum, d) => sum + d.value, 0);

  const CustomTooltip = ({ item }) => {
    if (!item) return null;
    return (
      <Box sx={{ backgroundColor: "#fff", padding: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold">{item.name}</Typography>
        <Typography variant="body2">Supply: {item.value}</Typography>
      </Box>
    );
  };

  return (
    <Box className='piechartHandle' position="relative" width={700} height={500}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fontWeight: 'normal',
          fontSize: 12,
          fill: '#222',
          textAnchor: 'middle',
          whiteSpace: 'pre-line',
        }
      }}
    >
      <svg width="0" height="0">
        <defs>
          <linearGradient id="a1" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#97FB1D" />
            <stop offset="100%" stopColor="#A2FB36" />
          </linearGradient>
          <linearGradient id="a2" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#A2FB36" />
            <stop offset="100%" stopColor="#A2FB36" />
          </linearGradient>
          <linearGradient id="a3" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#D8FDAB" />
            <stop offset="100%" stopColor="#D8FDAB" />
          </linearGradient>
        </defs>
      </svg>

      <PieChart
        width={700}
        height={500}
        series={[
          {
            data: data.map(d => ({
              id: d.id,
              value: d.value,
              label: d.shortname,
              color: d.color,
              ...d,
            })),
            innerRadius: 80,
            outerRadius: 200,
            paddingAngle: 5,
            cornerRadius: 4,
            cx: 350,
            cy: 250,
            slices: {
              stroke: "#c9b165",
              strokeWidth: 2
            },
            highlightScope: { faded: 'global', highlighted: 'item' },
            faded: { additionalRadius: -30, color: 'gray' },
            arcLabel: (d) => {
              const percent = ((d.value / totalValue) * 100).toFixed(1);
              if (percent < 10) return ''; // hide labels for slices < 20%
              return `${d.label}\n(${percent}%)`;
            },
          },
        ]}
        slotProps={{
          legend: { hidden: true },
          tooltip: {
            trigger: 'item',
            content: ({ item }) => <CustomTooltip item={item} />
          }
        }}
      />
    </Box>
  );
}
